export const navigationModel = [
  {
    label: 'Main',
    items: [
      {
        label: 'Dashboard',
        description: 'Overview and urgent actions',
        keywords: 'home control tower',
        icon: 'house',
        to: '/'
      },
      {
        label: 'Courier shipments',
        description: 'Parcels and door-to-door jobs',
        keywords: 'references orders parcels',
        icon: 'box-archive',
        to: '/References/courier',
        feature: 'courier_enabled',
        permission: 'shipments.view'
      },
      {
        label: 'Cargo shipments',
        description: 'Freight and air cargo jobs',
        keywords: 'references orders freight',
        icon: 'plane-up',
        to: '/References/cargo',
        feature: 'cargo_enabled',
        permission: 'shipments.view'
      },
      {
        label: 'Action workbench',
        description: 'SLA risks and exceptions',
        keywords: 'operations control tower urgent',
        icon: 'triangle-exclamation',
        to: '/operations',
        permission: 'operations.view'
      }
    ]
  },
  {
    label: 'Daily work',
    items: [
      {
        label: 'Pickup & delivery',
        description: 'Drivers, pickups and final delivery',
        keywords: 'dispatch driver mission collection',
        icon: 'truck-fast',
        items: [
          {
            label: 'Dispatch board',
            icon: 'truck-arrow-right',
            to: '/pickup-list',
            feature: 'dispatch_enabled',
            permission: 'dispatch.view'
          },
          {
            label: 'My dispatch',
            icon: 'route',
            to: '/my-pickups',
            feature: 'dispatch_enabled',
            permission: 'dispatch.view'
          },
          {
            label: 'Confirmed COD',
            description: 'Finance-approved collection history',
            icon: 'circle-check',
            to: '/confirmed-cod',
            feature: 'cod_enabled',
            permission: 'cod.view'
          }
        ]
      },
      {
        label: 'Shipment tools',
        description: 'Tracking, manifests and claims',
        keywords: 'cargo operations shipment tools',
        icon: 'boxes-stacked',
        items: [
          {
            label: 'Bulk tracking',
            icon: 'bars-staggered',
            to: '/bulk-tracking',
            permission: 'shipments.view'
          },
          {
            label: 'Console manifests',
            icon: 'boxes-packing',
            to: { name: 'ConsoleManifest' },
            permission: 'manifests.view'
          },
          {
            label: 'Claims & losses',
            icon: 'file-shield',
            to: '/claims',
            permission: 'claims.view'
          }
        ]
      },
      {
        label: 'Sales & billing',
        description: 'Customers, pricing and settlement',
        keywords: 'commercial finance quotes invoices',
        icon: 'wallet',
        items: [
          {
            label: 'Quotes',
            icon: 'file-signature',
            to: '/quotes',
            feature: 'quote_enabled',
            permission: 'quotes.view'
          },
          {
            label: 'Customers',
            icon: 'users',
            to: '/customers',
            permission: 'customers.view'
          },
          {
            label: 'Invoices',
            icon: 'file-invoice-dollar',
            to: '/Invoices',
            permission: 'invoices.view'
          },
          {
            label: 'Rate cards',
            icon: 'tags',
            to: '/rate-cards',
            permission: 'rates.view'
          },
          {
            label: 'COD ledger',
            icon: 'money-bill-transfer',
            to: '/pickup-list?focus=cod',
            feature: 'cod_enabled',
            permission: 'cod.view'
          }
        ]
      }
    ]
  },
  {
    label: 'Reports',
    items: [
      {
        label: 'Report center',
        description: 'Find all operational and business reports',
        keywords: 'analytics insights finance operations sales',
        icon: 'chart-pie',
        to: '/reports',
        permission: 'reports.view',
        items: [
          {
            label: 'Organizational reports',
            description: 'Persian-language reports for organizational workflows and operations.',
            icon: 'building',
            to: { name: 'OrganizationalReports' },
            permission: 'reports.view'
          },
          {
            label: 'Chart reports',
            description: 'Reports presented as charts for visual analysis.',
            icon: 'chart-bar',
            to: { name: 'ChartReports' },
            permission: 'reports.view'
          },
          {
            label: 'Useful reports',
            description: 'Frequently used operational, financial and management reports.',
            icon: 'list-check',
            to: { name: 'UsefulReports' },
            permission: 'reports.view'
          }
        ]
      }
    ]
  },
  {
    label: 'Legacy report navigation',
    visibleInMenu: false,
    items: [
      {
        label: 'Operations & finance',
        description: 'Essential management KPIs',
        keywords: 'dashboard management report profit sla',
        icon: 'chart-pie',
        to: '/reports/operations-dashboard',
        permission: 'reports.view'
      },
      {
        label: 'Sales report',
        description: 'Sales and profit overview',
        keywords: 'revenue profit',
        icon: 'chart-simple',
        to: { name: 'SalesReport' },
        permission: 'finance.profit.view'
      },
      {
        label: 'Operational reports',
        description: 'Shipments, routes and delivery',
        icon: 'chart-column',
        permission: 'reports.view',
        items: [
          { label: 'Order & waybill status', icon: 'clipboard-list', to: '/reports/order-status' },
          { label: 'Shipment pipeline', icon: 'filter', to: '/reports/pipeline-funnel' },
          { label: 'Flight report', icon: 'plane', to: '/reports/flight' },
          { label: 'Special cargo', icon: 'box', to: '/reports/special-cargo' },
          {
            label: 'Route performance',
            icon: 'route',
            to: '/reports/route-performance',
            permission: 'finance.profit.view'
          },
          { label: 'Volume & weight', icon: 'weight-scale', to: '/reports/volume-weight' },
          { label: 'Customs stock', icon: 'boxes-packing', to: '/stock-in-customs' },
          { label: 'Distribution status', icon: 'circle-check', to: '/delivered-package-report' },
          {
            label: 'Non-distribution reasons',
            icon: 'triangle-exclamation',
            to: '/non-distribution-report'
          },
          { label: 'Expired delivery', icon: 'clock', to: '/expired-delivery-report' },
          {
            label: 'Delivered percentage',
            icon: 'percentage',
            to: '/delivered-package-percent-report'
          }
        ]
      },
      {
        label: 'Business reports',
        description: 'Revenue, payments and customers',
        icon: 'chart-line',
        permission: 'reports.view',
        items: [
          {
            label: 'Revenue & shipping cost',
            icon: 'money-bill-trend-up',
            to: '/reports/revenue',
            permission: 'finance.profit.view'
          },
          { label: 'Payment & settlement', icon: 'credit-card', to: '/reports/payment' },
          { label: 'Customer performance', icon: 'users', to: '/reports/customer-performance' },
          { label: 'Popular routes', icon: 'route', to: '/reports/popular-routes' },
          {
            label: 'Revenue trend',
            icon: 'chart-line',
            to: '/reports/revenue-trend',
            permission: 'finance.profit.view'
          },
          {
            label: 'Customer analytics',
            icon: 'chart-pie',
            to: '/reports/customer-performance-chart'
          },
          { label: 'Daily traffic & revenue', icon: 'calendar-day', to: '/daily-report-traffic-income' },
          { label: 'Service comparison', icon: 'scale-balanced', to: '/date-report-traffic-income' },
          { label: 'COD service revenue', icon: 'hand-holding-dollar', to: '/cod-service-report' },
          {
            label: 'Traffic, revenue & average rate',
            icon: 'chart-simple',
            to: '/traffic-revenue-average-rate-reports'
          }
        ]
      },
      {
        label: 'Advanced reports',
        description: 'Specialized and statistical reports',
        icon: 'rectangle-list',
        permission: 'reports.view',
        items: [
          { label: 'Stalled counter traffic', icon: 'hourglass-half', to: '/undelivered-package-report' },
          { label: 'Daily performance', icon: 'chart-simple', to: '/total-count-income-month' },
          { label: 'Shipment trend', icon: 'arrow-trend-up', to: '/average-shipping-time' },
          {
            label: 'International trend',
            icon: 'plane-circle-check',
            to: '/average-shipping-international-time'
          },
          {
            label: 'Traffic by package',
            icon: 'box-open',
            to: '/traffic-income-average-per-package'
          },
          {
            label: 'Traffic by province',
            icon: 'map-location-dot',
            to: '/traffic-report-of-incoming-shipment-by-province'
          },
          {
            label: 'Weight frequency',
            icon: 'weight-scale',
            to: '/report-per-weight-and-package-type'
          },
          {
            label: 'Redistribution',
            icon: 'arrows-rotate',
            to: '/report-revenue-from-suspended-counters'
          },
          {
            label: 'Postal & national code',
            icon: 'address-card',
            to: '/national-code-and-postal-code-report'
          }
        ]
      }
    ]
  },
  {
    label: 'System setup',
    items: [
      {
        label: 'Company settings',
        description: 'Brand, rules and feature settings',
        keywords: 'general configuration',
        icon: 'gear',
        to: '/settings',
        permission: 'system.settings.manage'
      },
      {
        label: 'Users & partners',
        icon: 'user-group',
        items: [
          { label: 'Administrators', icon: 'user-shield', to: '/admins', permission: 'users.manage' },
          { label: 'Agents', icon: 'headset', to: '/agents' },
          { label: 'Airlines', icon: 'plane', to: '/airlines' },
          { label: 'Agencies', icon: 'building', to: '/agency' }
        ]
      },
      {
        label: 'Network & locations',
        icon: 'map',
        items: [
          { label: 'Base locations', icon: 'location-dot', to: '/base-locations' },
          { label: 'Countries', icon: 'earth-asia', to: '/countries' },
          { label: 'Cities', icon: 'city', to: '/cities' }
        ]
      },
      {
        label: 'Master data',
        icon: 'sliders',
        items: [
          { label: 'Services', icon: 'list-check', to: '/services' },
          { label: 'Packaging', icon: 'box', to: '/package-items' },
          { label: 'Tracking statuses', icon: 'shuffle', to: '/tracking-status' },
          { label: 'Payment methods', icon: 'credit-card', to: '/payment-methods' },
          { label: 'Currencies', icon: 'coins', to: '/currencies' },
          { label: 'Carrying terms', icon: 'file-contract', to: '/carrying-term' },
          { label: 'Notes', icon: 'clipboard', to: '/notes' }
        ]
      },
      {
        label: 'System health',
        icon: 'heart-pulse',
        to: '/system-health',
        permission: 'system.health.view'
      }
    ]
  }
];
